import * as R from 'ramda'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'

import { createSurveyByType } from 'actions'
import ChooseHelpdeskModalPresentation from 'components/Admin/Surveys/ChooseHelpdeskModal'
import { hasSurveyByType } from 'reducers'
import { navBarMenuContext } from 'organisms/NavBar/context'

class ChooseHelpdeskModal extends React.Component {
  static contextType = navBarMenuContext

  static propTypes = {
    createSurveyByType: PropTypes.func,
    handleClose: PropTypes.func,
    hasSurvey: PropTypes.func,
    history: PropTypes.object,
    isOpenModal: PropTypes.bool.isRequired,
    workspaceToken: PropTypes.bool.isRequired,
  }

  state = {
    surveyType: '',
    isLoading: false,
  }

  clearState = () => {
    this.setState({
      surveyType: '',
      isLoading: false,
    })
  }

  handleOnClick = async () => {
    this.setState({
      isLoading: true,
    })
    const surveyData = await this.props.createSurveyByType(this.state.surveyType)
    this.setState({
      surveyType: '',
    })
    this.props.history.push(
      `/${this.props.workspaceToken}/settings/surveys/${surveyData.id}/settings`
    )
    this.context.updateContextData()
  }

  selectSurvey = (type) => {
    this.setState({
      disableCreateButton: false,
      surveyType: type,
    })
  }

  render() {
    return (
      <ChooseHelpdeskModalPresentation
        isOpenModal={this.props.isOpenModal}
        handleClose={R.compose(this.props.handleClose, this.clearState)}
        hasSurvey={this.props.hasSurvey}
        handleOnClick={this.handleOnClick}
        selectSurvey={this.selectSurvey}
        isLoading={this.state.isLoading}
      />
    )
  }
}

const mapState = (state) => ({
  hasSurvey: (type) => hasSurveyByType(state, type),
})

const mapDispatch = (dispatch) => ({
  createSurveyByType: (surveyType) => dispatch(createSurveyByType(surveyType)),
})

export default compose(withRouter, connect(mapState, mapDispatch))(ChooseHelpdeskModal)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/ChooseHelpdeskModal.js